/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateJobListSortCriteria {
    getFixupPrototypeFunction() { return TemplateJobListSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<TemplateJobListSortCriteria>): TemplateJobListSortCriteria {
        let obj = Object.assign(new TemplateJobListSortCriteria(), model);
        TemplateJobListSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateJobListSortCriteria>): TemplateJobListSortCriteria {
        if (!model) return null;
        return TemplateJobListSortCriteria.newInstance(<TemplateJobListSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateJobListSortCriteria) {
        if (!obj) return;

        models.TemplateJobListSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateJobListSortCriteria): boolean {
        Object.setPrototypeOf(obj, TemplateJobListSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.TemplateJobListSortColumn;

    ascending: boolean;

}
